import * as React from 'react';
import { useSelector } from 'react-redux';

import { ChatHeaderCard } from '../../components/ChatHeader';
import { BLOB_ID } from '../../constants/blobId';
import { currentOpenChatIDSelector } from '../../selectors';
import { selectChatHeaderCard } from '../../selectors/chatHeaderCardSelector';
import { useApplicationContext } from '../../utils/applicationContext';
import { ChatHeaderOfferContainer } from '../ChatHeaderOfferContainer';

export const ChatHeaderCardPreviewContainer = () => {
  const { config } = useApplicationContext();

  const chatId = useSelector(currentOpenChatIDSelector);

  const isCustomHeaderEnabled = config.get<boolean>('frontend-chats.customHeader.Enabled');

  const headerCard = useSelector(selectChatHeaderCard);

  const isNewChat = chatId === BLOB_ID;

  if (!isCustomHeaderEnabled || isNewChat) {
    return <ChatHeaderOfferContainer />;
  }

  if (!headerCard) {
    return null;
  }

  return <ChatHeaderCard {...headerCard} />;
};
